import videopage from "./videopage"


videopage.install = function(Vue) {
    Vue.component(videopage.name, videopage);
}

export default videopage
